// extracted by mini-css-extract-plugin
module.exports = {"plane":"plane-2Pl9e","plane_return":"plane_return-3xtwp"};